import(/* webpackMode: "eager", webpackExports: ["FooterEs"] */ "/vercel/path0/src/components/es/footerEs.comp.tsx");
